import { emitter } from '@/shared/event-bus';

export default class LoginService {
  // Vue 3 / bootstrap-vue-next : le login modal n'est plus déclenché par `$emit('bv::show::modal')`.
  // On émet un événement global ; app.vue écoute et affiche le modal (wiring en P3).
  public openLogin(): void {
    emitter.emit('show-login');
  }
}
